import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

export default function BaseMap({
  children,
  mapStyle,
  zoomPosition = "bottomright",
  className = "",
  visibleZoom = true,
  zoomLevel = 12,
  center = [45.4685, 9.1824],
  scrollWheelZoom = true,
}) {
  // Generate a unique key for the map container
  const mapKey = `${center[0]}-${center[1]}-${zoomLevel}`;

  return (
    <MapContainer
      key={mapKey}
      style={{ height: "100vh", width: "100%", ...mapStyle }}
      zoom={zoomLevel}
      center={center}
      zoomControl={false}
      className={className}
      scrollWheelZoom={scrollWheelZoom}
    >
      <TileLayer
        attribution='Data by &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>'
        url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png"
      />
      <TileLayer
        attribution='Data by &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>'
        url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
      />
      {children}

      {visibleZoom && <ZoomControl position={zoomPosition} />}
    </MapContainer>
  );
}
